<template>
  <div class="scan-div">
    <el-card class="scan-box-card">
      <el-row
        :gutter="20"
        type="flex"
      >
        <div class="grid-content bg-purple"></div>
        <el-col :span="9" class="labelpadding">
          <el-form class="el-form-scanarea">
            <el-form-item class="scan-label" label="扫描区">
              <el-input :disabled="InputDisable"
                        class="scanarea-style"
                        contenteditable="plaintext-only"
                        id="input_scancode_id"
                        placeholder="请输入条码"
                        v-model="_value"
                        ref="code"
                        @focus="getInputFocus($event)"
                        @keyup.enter.native="input_ScanArea_Click($event)"
              >
              </el-input>
              <!-- onKeyUp="value=value.replace(/[\W]/g,'')" -->
            </el-form-item>
            <el-input v-show="false"></el-input>
          </el-form>
        </el-col>
        <el-col :span="7" class="errorlabelpadding">
          <div class="error-message-div">
              <span :title="errormessage" :class="{ errormsgdiv: true, oversize: checkFontSize() }">
                <strong>{{ errormessage }}</strong></span
              >
          </div>
        </el-col>
        <el-col :span="5" class="device_div" v-if="ShowDevice">
          <device-status
            class="device-status-style" :device-state-label-visible="true"
            :device-items="myDeviceItems"
          ></device-status>
        </el-col>
        <el-col :span="3" class="package_img" v-if="ShowPic">
          <img id="dashboardModel.captureimage" style="width: 100%;height: 100%" src="../../../../public/img/1.jpg"/>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import DeviceStatus from "@/views/components/DeviceStatus/deviceStatus";
  import Enumerable from "linq";

  export default {
    props: ["value", "errormessage", 'ShowDevice', 'ShowPic', 'InputDisable'],
    name: "ScanWithFullHeight",
    components: {DeviceStatus},
    watch: {
      deviceItems: {
        handler(newone, oldone) {
          if (newone != null && newone.length > 0) {
            this.deviceStateLabelVisible = true;
          } else {
          }
        }
      }
    },

    mounted() {
      debugger;
      var _this = this;
      if (typeof obj_DeviceItems_Core !== "undefined") {
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceStateRefreshState", function (value) {
          debugger
          _this.deviceItems = [];
          _this.deviceItems.push(...value);
        });
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceAddOrUpdateDriver", function (name, status) {
          let c = Enumerable.from(_this.deviceItems);
          let item = c.firstOrDefault(f => f.name === name);
          if (item) {
            item.status = status ? 'true' : 'false';
          }
        });
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceSetOrUpdateState", function (value) {
          for (let i = 0; i < value.length; i++) {
            let c = Enumerable.from(_this.deviceItems);
            let e = value[i];
            let item = c.firstOrDefault(f => f.name === e.name);
            if (item) {
              item.status = e.status;
              item.title = e.title;
            } else {
              _this.deviceItems.push(e)
            }
          }
        });
        setTimeout(() => {
          this.refreshCameraState()
        }, 2000);
      }
      if (typeof obj_ScanForAcceptPacket !== "undefined") {
        debugger
        obj_ScanForAcceptPacket.regist_getdevicestate(this.getdevicestatecallback);
      }
      if (typeof obj_ScanForAcceptPacketGetOn !== "undefined") {
        obj_ScanForAcceptPacketGetOn.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof obj_ScanForGetOn !== "undefined") {
        obj_ScanForGetOn.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof obj_ScanForSixScan !== "undefined") {
        obj_ScanForSixScan.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof obj_ScanForRoughSorting !== "undefined") {
        obj_ScanForRoughSorting.regist_getdevicestate(this.getdevicestatecallback);
      }
      // for (let i = 0; i < 12; i++) {
      //   this.deviceItems.push({
      //     title: "无数据",
      //     status: "defult",
      //     name: "设备" + (i + 1),
      //   });
      // }
    },
    computed: {
      _value: {
        get() {
          return this.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, '').toUpperCase();
        },
        set(val) {
          this.$emit("input", val);
        }
      },
      myDeviceItems: function () {
        console.log('myDeviceItems');
        if (this.deviceItems.length) {
          return this.deviceItems;
        }
        let newItems = [];
        for (let i = 0; i < 8; i++) {
          newItems.push({
            name: "设备" + i.toString(),
            title: "设备" + i.toString(),
            status: "false"
          });
        }
        return newItems
      }
    },
    data() {
      return {
        deviceStateLabelVisible: true,
        deviceItems: []
        // deviceItems: [],
      };
    },
    methods: {

      getInputFocus(e) {
        e.currentTarget.select();
        this.$emit("inputFocus", e);
      },
      checkFontSize() {
        if (/\s*\d层/.test(this.errormessage)) {
          return true;
        }
        return false;
      },
      input_ScanArea_Click(e) {
        e.target.select();
        this.$emit("getCode", e);
        this._value = "";
      },
      setFocus() {
        this.$refs.code.focus();
      },
      selectInput() {
        this.$refs.code.select();
      },
      refreshCameraState() {
        if (typeof obj_DeviceItems_Core !== "undefined") {
          let json = obj_DeviceItems_Core.getRefreshCameraState();
          this.deviceItems = JSON.parse(json);
        }
      },
      getdevicestatecallback(items) {
        debugger
        console.log(items)
        this.deviceItems = [];
        this.deviceItems.push(...items);
      },
    }
  };
</script>

<style lang="less">
  @import "scan.less";
  .scan-box-card > .el-card__body {
    padding-top: 0px;
    padding-bottom: 0px;
    height: 100%;
  }

  .scan-box-card > .el-card__body > div {
    height: 100%;
  }

  .scan-label .el-form-item__label {
    color: @primaryColor;
    width: 120px;
  }

  .scan-label .el-form-item__content {
    line-height: normal;
  }
</style>
<style scoped lang="less">
  .scan-label {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .scan-div {
    border: 1px @primaryBorderColor solid;

    > .el-card {
      border: none;
    }
  }



  .labelpadding {
    padding: 0px 5px 0px 5px;
    /* padding-top: 0px; */
  }

  .errorlabelpadding {
    padding-top: 0px;
  }


  .devicestate-style {
    margin-top: 10px;
    text-align: right;
    padding: 15px 10px;
  }

  .scanarea-style {
    /*width: 430px;*/
    /* margin-top: 5px; */
    width: 85%;
  }


  .el-form-item-scanarea {
    display: inline;
  }

  .el-form-scanarea {
    /*margin-top: 10px;*/

    position: relative;
    top: 50%;
    transform: translateY(-50%);

    /deep/ .el-form-item {
      margin-bottom: 0px;
    }
  }

  .el-form-scanarea /deep/ .el-form-item__label {
    /* font-size: 1.370rem; */
    font-size: 1.30rem;
  }

  .oversize {
    font-size: 50pt;
  }

  @media only screen and (max-width: 767px) {
    .scanarea-style {
      width: 65%;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .scanarea-style {
      width: 75%;
    }
  }

  @media only screen and (min-width: 990px) and (max-width: 1200px) {
    .scanarea-style {
      width: 80%;
    }

    .el-form-scanarea {
      margin-top: 0px;
    }

    .device_div {
      /*margin-top: -10px;*/
    }
  }

  .scan-box-card {
    /* height: 125px; */
    background: @cardBackColor;
    // height: 135px;
    height: 100%;
  }

  /* el-divider 修改高度&虚线效果 */
  .el-divider--horizontal {
    margin: 6px 0;
    background: 0 0;
    border-top: 40px dashed #e8eaec;
  }

  @media only screen and (max-height: 769px) and (min-height: 728px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media only screen and (min-height: 769px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media only screen and (max-height: 720px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

</style>
